/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/rematch';
import TableReports from './TableReports';
import TableLeads from './TableLeads';
import LeadReports from './LeadReports';
import TableCampaigns from '../MarketingTab/TableCampaigns';
import { TabFrame, TabFrameProps, TabDataObject } from '../TabFrame';
import { hasAccessTo } from '../../../../utils/auth.utils';
import { READ_MARKETING } from '../../../../constants/actions.constants';
import { MEDSPA_ADMIN_ROLE } from '../../../../constants/general.constants';

const InsightsTab = ({ state }: { state?: string }) => {
  const { permissions, roleName } = useSelector(({ auth }: RootState) => auth);
  const isMedspaAdmin = roleName === MEDSPA_ADMIN_ROLE;

  const leadsTab: TabDataObject = {
    leads: {
      label: 'Lead Manager',
      order: 1,
      target: <TableLeads practitionerView={!isMedspaAdmin} />,
    },
    lead_reports: {
      label: 'Lead Reports',
      order: 2,
      target: <LeadReports practitionerView={!isMedspaAdmin} isMedspaAdmin={isMedspaAdmin} />,
    },
  };

  const campaignsTab: TabDataObject = !isMedspaAdmin
    ? {
      campaigns: {
        label: 'Text Messages',
        order: 3,
        target: <TableCampaigns />,
      },
    }
    : {};

  const tabs: TabDataObject = {
    reports: {
      label: 'Client Reports',
      order: 0,
      target: <TableReports practitionerView={!isMedspaAdmin} isMedspaAdmin={isMedspaAdmin} />,
    },
    ...leadsTab,
    ...campaignsTab,
  };

  const tabProps: TabFrameProps = {
    path: isMedspaAdmin ? '/medspa-admin/marketing' : '/practitioner/marketing',
    tabs,
    state,
  };

  if (!hasAccessTo(READ_MARKETING, permissions) && !isMedspaAdmin) {
    return null;
  }

  return <TabFrame {...tabProps} />;
};

export { InsightsTab, InsightsTab as default };
